import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { MerchantService } from 'app/services';
import { MerchantStatusEnum } from 'app/models';

@Component({
    selector: 'review-partner-info',
    templateUrl: './review-partner-info.component.html',
    styleUrls: ['./review-partner-info.component.scss',
        '../../../../../../../styles/sidebar.scss',
        '../../../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class ReviewPartnerInfoComponent implements OnInit {
    public merchantId: number = 0;
    @Input()
    set _merchantId(value: number) {
        this.merchantId = value;
        if (this.merchantId > 0) {
            this.getReviewPartnerInfo();
        }
    }

    public showReviewPartnerInfoSideBar: boolean = false;
    @Input()
    set _showReviewPartnerInfoSideBar(value: boolean) {
        this.showReviewPartnerInfoSideBar = value;
    }

    @Output() changedShowReviewPartnerInfoSideBarEmit = new EventEmitter<boolean>();
    changedShowReviewPartnerInfoSideBar(increased: any) {
        this.changedShowReviewPartnerInfoSideBarEmit.emit(increased);
    }

    constructor(private messageService: MessageService,
        private merchantService: MerchantService, private router: Router) { }

    public merchantInfo: any = {};

    public loading: boolean = false;

    ngOnInit(): void {
    }

    public getReviewPartnerInfo() {
        this.loading = true;
        const dto = {
            MerchantId: this.merchantId
        };
        this.merchantService.getReviewPartnerInfo(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }
            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.merchantInfo = data;
            this.loading = false;
        }).catch(err => {
            this.loading = false;
            throw err;
        });
    }

    public beginReview() {
        const payload = {
            MerchantId: this.merchantId,
            StatusId: MerchantStatusEnum.OnGoingFinalReview
        };
        this.merchantService.merchantStatusChange(payload, this.messageService).then(res => {
            if(!res?.Success){
                this.messageService.add({ severity: 'error', summary: 'Error', detail: res.ErrorMessage });
                return;
            }
            //TODO: Store Onboarding Admin Final Approval Page
            // localStorage.setItem('reviewMerchantId', JSON.stringify(this.merchantId));
            // this.router.navigate(['merchant-store-onboarding'], { skipLocationChange: true });
            this.showReviewPartnerInfoSideBar = false;
            this.cancel();
        }).catch(err => {
            throw err;
        });
    }

    cancel() {
        this.changedShowReviewPartnerInfoSideBar(this.showReviewPartnerInfoSideBar);
    }
}
